module.exports = __webpack_public_path__ + "static/media/27-11-2020.8aa41981.gif";